import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  toasts: any[] = [];

  show(message: string, type: 'success' | 'danger' | 'warning' | 'info' = 'info') {
    const toast = { message, type };
    this.toasts.push(toast);

    setTimeout(() => this.remove(toast), 4000); // autodestruir después de 4s
  }

  showError(message: string) {
    const toast = { message, type: 'danger' };
    this.toasts.push(toast);

    setTimeout(() => this.remove(toast), 4000); // autodestruir después de 4s
  }

  remove(toast: any) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

  clear() {
    this.toasts = [];
  }
}
